import React from "react";
import ActiveBadge from "../../../components/ActiveBadge";
import Chip from "../../../components/Chip";

// Columns of the Template list. `start` is the row number offset of the current page.
export const getTemplateColumns = (start) => [
  { key: "id", label: "S.No", width: "70px", sortable: false, render: (row) => <span className="text-xs text-text_muted">{start + row.__index + 1}</span> },
  {
    key: "name",
    label: "Template",
    sortable: true,
    render: (row) => (
      <div className="flex min-w-0 flex-col">
        <span className="truncate font-medium text-text_primary">{row.name}</span>
        <span className="truncate font-mono text-[11px] text-text_muted">{row.code}</span>
      </div>
    ),
  },
  { key: "channel_fid", label: "Channel", sortable: true, render: (row) => <span className="text-xs text-text_secondary">{row.channel?.name ?? "—"}</span> },
  {
    key: "trigger_fid",
    label: "Trigger",
    sortable: true,
    render: (row) => (row.trigger ? <span className="text-xs text-text_secondary">{row.trigger.name}</span> : <Chip tone="brand">Generic</Chip>),
  },
  { key: "locale", label: "Locale", sortable: true, render: (row) => <span className="font-mono text-xs text-text_secondary">{row.locale}</span> },
  {
    key: "version_no",
    label: "Version",
    sortable: true,
    render: (row) => (
      <div className="flex flex-wrap items-center gap-1">
        <Chip>v{row.version_no}</Chip>
        {row.digest_content && <Chip tone="info">Digest</Chip>}
      </div>
    ),
  },
  { key: "is_activated", label: "Status", sortable: true, render: (row) => <ActiveBadge active={row.is_activated} /> },
];
